/**
 * Ограждение раздела по правам (§11.4).
 *
 * Принцип спеки: недоступное не исчезает. Раздел остаётся в шапке и по ссылке
 * открывается — но вместо содержимого объясняет, какого права не хватает и у
 * кого оно есть. Иначе люди звонят друг другу «а у меня нет такой кнопки».
 */
import { Link } from 'react-router-dom'
import type { PermissionCode } from '@shared/types.ts'
import { useApp } from '../store/app-store.js'
import { texts } from '../texts.js'
import './screens.css'

export interface RequirePermissionProps {
  /** Достаточно любого из перечисленных прав. */
  need: PermissionCode | PermissionCode[]
  /** Причина отказа дословно из §12.7. */
  reason?: string
  children: React.ReactNode
}

export function RequirePermission({ need, reason = texts.denied.generic, children }: RequirePermissionProps) {
  const permissions = useApp((s) => s.bootstrap?.user.permissions) ?? []
  const required = Array.isArray(need) ? need : [need]
  const allowed = required.some((code) => permissions.includes(code))

  if (allowed) return <>{children}</>

  return (
    <div className="state" role="alert">
      <div className="state__box">
        <h1 className="state__title">{texts.denied.title}</h1>
        <p className="state__text">{reason}</p>
        <div className="state__actions">
          <Link className="sbtn" to="/brands">{texts.action.backToTable}</Link>
        </div>
      </div>
    </div>
  )
}
